import { BaseService } from "services/_baseService";


class RoomTypesService extends BaseService<any> {
  constructor() {
    super("room-types");
  }
}
export default new RoomTypesService();
